import { Store, useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import * as PermitCreateState from '../state/PermitCreateState.ts';
import {
    NumberSingleSelectionSlideIn,
    Option,
} from '../../ui/slidein/SingleSelectionSlideIn.tsx';
import { Translation } from '../../common/i18n/Text.ts';
import * as PermitCreateTexts from '../i18n/PermitCreateTexts.ts';
import * as PermitTypeState from '../../common/state/PermitTypeState.ts';
import { isDefined } from 'dg-web-shared/lib/MaybeV2.ts';
import { range } from 'dg-web-shared/lib/ArrayUtil.ts';

export interface Texts {
    Heading: Translation;
    Caption: Translation;
    Vignette: (i: number) => string;
}

export function VignetteAmountSlideIn() {
    const { storeState, update } = useStore(store => {
        const config = PermitCreateState.Config.get(store);
        return {
            config: config,
            layout: PermitCreateState.Layout.get(store),
            permitType: PermitTypeState.getById(store, config.permitTypeId),
        };
    });
    const { language } = useLanguage();

    const txt = PermitCreateTexts.vignetteAmount[language];

    const permitType = storeState.permitType;
    const options: Option<number>[] = isDefined(permitType)
        ? range(permitType.maxLicenses * 2 + 1).map((i: number) => {
              return {
                  id: i,
                  displayText: txt.Vignette(i),
              };
          })
        : [];

    return (
        <NumberSingleSelectionSlideIn
            open={storeState.layout.vignetteCountSelectionOpen}
            heading={txt.Heading()}
            selection={storeState.config.vigetteAmount}
            options={options}
            onSelect={(v: number) =>
                update((store: Store): string => {
                    PermitCreateState.Config.stateWrite(store, {
                        vigetteAmount: v,
                    });
                    PermitCreateState.Layout.stateWrite(store, {
                        vignetteCountSelectionOpen: false,
                    });
                    return 'VignetteAmountSlideIn-SelectVignetteAmount';
                })
            }
            onLeftActionClick={() =>
                update(store =>
                    PermitCreateState.Layout.stateWrite(store, {
                        vignetteCountSelectionOpen: false,
                    }),
                )
            }
            outsideBody
        />
    );
}
